import Button from "./Button";
import styles from "./ServerList.module.css";
import Server from "./Server";
import React from "react";

function ServerList({ servData, removeEmployee }) {
  let chef = servData.filter((c) => c.category == "Chef").length;
  let coordinator = servData.filter((c) => c.category == "Coordinator").length;
  let bar = servData.filter((c) => c.category == "Bar").length;
  let server = servData.filter((c) => c.category == "Server").length;
  let dish = servData.filter((c) => c.category == "Dish").length;
  let count;

  // const [serverData, setServerData] = useState({});

  return (
    <>
      {servData
        //.filter((c) => c.category == "Coordinator")
        .map((sd, index) => {
          if (sd.category == "Coordinator") {
            return <Server sd={sd} disabled={coordinator <= 1 ? true : false} removeEmployee={removeEmployee} key={sd.idServers} />;
          }
        })}
      {servData
        //.filter((c) => c.category == "Coordinator")
        .map((sd, index) => {
          if (sd.category == "Executive Chef") {
            return <Server sd={sd} disabled={true} removeEmployee={removeEmployee} key={sd.idServers} />;
          }
        })}
      {servData
        // .filter((c) => c.category == "Chef")
        .map((sd, index) => {
          if (sd.category == "Chef") {
            return <Server sd={sd} disabled={chef <= 1 ? true : false} removeEmployee={removeEmployee} key={sd.idServers} />;
          }
        })}
      {servData
        //.filter((c) => c.category == "Bar")
        .map((sd, index) => {
          if (sd.category == "Bar") {
            return <Server sd={sd} disabled={bar <= 1 ? true : false} removeEmployee={removeEmployee} key={sd.idServers} />;
          }
        })}
      {servData
        //.filter((c) => c.category == "Server")
        .map((sd, index) => {
          if (sd.category == "Server") {
            return <Server sd={sd} disabled={server <= 1 ? true : false} removeEmployee={removeEmployee} key={sd.idServers} />;
          }
        })}
      {servData
        //.filter((c) => c.category == "Server")
        .map((sd, index) => {
          if (sd.category == "Dish") {
            return <Server sd={sd} disabled={server <= 1 ? true : false} removeEmployee={removeEmployee} key={sd.idServers} />;
          }
        })}
    </>
  );
}

export default ServerList;
